<template>
    <div class="container">
        <div class="container_switch">
        <div style="color:black;font-size:20px;font-weight:bold" class="BT">声光精准防控设备控制</div>
        <!--绿叶蝉 -->
        <div>
            <div v-if="LV_isOnline" style="color:#33cc00">
                在线&nbsp;
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="LV_title">
                <span>测报设备:</span>
            </div>
            <!-- 一号控制开关 -->
            <div class="LV_1">
                <span>开关一：</span>
                <el-switch
                    v-model="KG"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff'>
                </el-switch>
            </div>
            <div class="LV_2">
            <!-- 二号控制开关 -->
                <span>开关二：</span>
                <el-switch
                    v-model="KG_L_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_L_2'>
                </el-switch>
            </div>
            <div class="LV_3">
            <!-- 三号控制开关 -->
                <span>开关三：</span>
                <el-switch
                    v-model="KG_L_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_L_3'>
                </el-switch>
            </div>
            <div class="LV_4">
            <!-- 四号控制开关 -->
                <span>开关四：</span>
                <el-switch
                    v-model="KG_L_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_L_4'>
                </el-switch>
            </div>
        </div>
        <!--1号设备 -->
        <div class="DEVICE_1">
            <div v-if="DEVICE_1_isOnline" style="color:#33cc00">
                在线&nbsp;
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="Dev_1_title">
                <span>一号设备:</span>
            </div>
            <div class="Dev_1_1">
                <!-- 1号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;源：</span>
                <el-switch
                    v-model="KG_1"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_1'>
                </el-switch>
            </div>
            <div class="Dev_1_2">
                <!-- 2号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;乐：</span>
                <el-switch
                    v-model="KG_1_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_1_2'>
                </el-switch>
            </div>
            <div class="JK_1"><a class="moniter" href="https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=at.28dv2fby7qvwmcpjc3ichv7naom5twgi-6ezfjk35uv-0u1iw2k-rua6i9umn&validCode=YUHEGI&deviceSerial=F01130539&channelNo=1">监控设备</a></div>
            <div class="Dev_1_3">
                <!-- 3号开关 -->
                <span>杀虫灯：</span>
                <el-switch
                    v-model="KG_1_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_1_3'>
                </el-switch>
            </div>
            <div class="Dev_1_4">
                <!-- 4号开关 -->
                <span>摄像头：</span>
                <el-switch
                    v-model="KG_1_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_1_4'>
                </el-switch>
            </div>
        </div>
         <!--2号设备 -->
        <div class="DEVICE_2">
        <div v-if="DEVICE_2_isOnline" style="color:#33cc00">
                在线
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="Dev_2_title">
                <span>二号设备:</span>
            </div>
            <div class="Dev_2_1">
                <!-- 1号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;源：</span>
                <el-switch
                    v-model="KG_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_2'>
                </el-switch>
            </div>
            <div class="Dev_2_2">
                <!-- 2号开关 -->
                <span>音&emsp;乐：</span>
                <el-switch
                    v-model="KG_2_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_2_2'>
                </el-switch>
            </div>
            <div class="Dev_2_3">
                <!-- 3号开关 -->
                <span>杀虫灯：</span>
                <el-switch
                    v-model="KG_2_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_2_3'>
                </el-switch>
            </div>
            <div class="Dev_2_4">
                <!-- 4号开关 -->
                <span>粉&emsp;碎：</span>
                <el-switch
                    v-model="KG_2_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_2_4'>
                </el-switch>
            </div>
        </div>
        <!--3号设备 -->
        <div class="DEVICE_3">
        <div v-if="DEVICE_3_isOnline" style="color:#33cc00">
                在线
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="Dev_3_title">
                <span>三号设备:</span>
            </div>
            <div class="Dev_3_1">
                <!-- 1号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;源：</span>
                <el-switch
                    v-model="KG_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_3'>
                </el-switch>
            </div>
            <div class="Dev_3_2">
                <!-- 2号开关 -->
                <span>音&emsp;乐：</span>
                <el-switch
                    v-model="KG_3_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_3_2'>
                </el-switch>
            </div>
            <div class="JK_3"><a class="moniter" href="https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=at.28dv2fby7qvwmcpjc3ichv7naom5twgi-6ezfjk35uv-0u1iw2k-rua6i9umn&validCode=YUHEGI&deviceSerial=F01130165&channelNo=1">监控设备</a></div>
            <div class="Dev_3_3">
                <!-- 3号开关 -->
                <span>杀虫灯：</span>
                <el-switch
                    v-model="KG_3_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_3_3'>
                </el-switch>
            </div>
            <div class="Dev_3_4">
                <!-- 4号开关 -->
                <span>摄像头：</span>
                <el-switch
                    v-model="KG_3_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_3_4'>
                </el-switch>
            </div>
        </div>
        <!--4号设备 -->
        <div class="DEVICE_4">
        <div v-if="DEVICE_4_isOnline" style="color:#33cc00">
                在线
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="Dev_4_title">
                <span>四号设备:</span>
            </div>
            <div class="Dev_4_1">
                <!-- 1号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;源：</span>
                <el-switch
                    v-model="KG_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_4'>
                </el-switch>
            </div>
            <div class="Dev_4_2">
                <!-- 2号开关 -->
                <span>音&emsp;乐：</span>
                <el-switch
                    v-model="KG_4_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_4_2'>
                </el-switch>
            </div>
            <div class="Dev_4_3">
                <!-- 3号开关 -->
                <span>杀虫灯：</span>
                <el-switch
                    v-model="KG_4_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_4_3'>
                </el-switch>
            </div>
            <div class="Dev_4_4">
                <!-- 4号开关 -->
                <span>粉&emsp;碎：</span>
                <el-switch
                    v-model="KG_4_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_4_4'>
                </el-switch>
            </div>
        </div>
        <!--5号设备 -->
        <div class="DEVICE_5">
        <div v-if="DEVICE_5_isOnline" style="color:#33cc00">
                在线
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="Dev_5_title">
                <span>五号设备:</span>
            </div>
            <div class="Dev_5_1">
                <!-- 1号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;源：</span>
                <el-switch
                    v-model="KG_5"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_5'>
                </el-switch>
            </div>
            <div class="Dev_5_2">
                <!-- 2号开关 -->
                <span>音&emsp;乐：</span>
                <el-switch
                    v-model="KG_5_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_5_2'>
                </el-switch>
            </div>
            <div class="JK_5"><a class="moniter" href="https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=at.28dv2fby7qvwmcpjc3ichv7naom5twgi-6ezfjk35uv-0u1iw2k-rua6i9umn&validCode=YUHEGI&deviceSerial=F01130172&channelNo=1">监控设备</a></div>
            <div class="Dev_5_3">
                <!-- 3号开关 -->
                <span>杀虫灯：</span>
                <el-switch
                    v-model="KG_5_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_5_3'>
                </el-switch>
            </div>
            <div class="Dev_5_4">
                <!-- 4号开关 -->
                <span>摄像头：</span>
                <el-switch
                    v-model="KG_5_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_5_4'>
                </el-switch>
            </div>
        </div>
        <!--6号设备 -->
        <div class="DEVICE_6">
        <div v-if="DEVICE_6_isOnline" style="color:#33cc00">
                在线
            </div>
            <div v-else style="color:#F73809">
                离线
            </div>
            <div class="Dev_6_title">
                <span>六号设备:</span>
            </div>
            <div class="Dev_6_1">
                <!-- 1号开关 -->
                <span>音&nbsp;&nbsp;&nbsp;&nbsp;源：</span>
                <el-switch
                    v-model="KG_6"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_6'>
                </el-switch>
            </div>
            <div class="Dev_6_2">
                <!-- 2号开关 -->
                <span>音&emsp;乐：</span>
                <el-switch
                    v-model="KG_6_2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_6_2'>
                </el-switch>
            </div>
            <div class="Dev_6_3">
                <!-- 3号开关 -->
                <span>杀虫灯：</span>
                <el-switch
                    v-model="KG_6_3"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_6_3'>
                </el-switch>
            </div>
            <div class="Dev_6_4">
                <!-- 4号开关 -->
                <span>粉&emsp;碎：</span>
                <el-switch
                    v-model="KG_6_4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change='Onoff_6_4'>
                </el-switch>
            </div>
        </div>
        </div>
        <div class="MU">
            <cebao class="cebao" />
            <cbdata class="cbdata" />
        </div>  
        
        <div class="beian">网站备案号 :浙ICP备<a href="http://beian.miit.gov.cn">20007408</a>号-2</div>
    </div>
    
</template>
<script>
import cebao from './cebao.vue'
import cbdata from './cbdata.vue'
import jiankong from './jiankong.vue'
export default ({
    name:'Home',
    components:{
        cebao,
        cbdata,
        jiankong
    },
    data(){
        
        return{
            LV_isOnline:'',
            DEVICE_1_isOnline:'',
            DEVICE_2_isOnline:'',
            DEVICE_3_isOnline:'',
            DEVICE_4_isOnline:'',
            DEVICE_5_isOnline:'',
            DEVICE_6_isOnline:'',
            KG: '',KG_L_2:true,KG_L_3:true,KG_L_4:true,//小绿叶蝉的开关状态,
            KG_1:true,KG_1_2:true,KG_1_3:true,KG_1_4:true,//一号设备
            KG_2:true,KG_2_2:true,KG_2_3:true,KG_2_4:true,//2号设备
            KG_3:true,KG_3_2:true,KG_3_3:true,KG_3_4:true,//三号设备
            KG_4:true,KG_4_2:true,KG_4_3:true,KG_4_4:true,//四号设备
            KG_5:true,KG_5_2:true,KG_5_3:true,KG_5_4:true,//五号设备
            KG_6:true,KG_6_2:true,KG_6_3:true,KG_6_4:true,//六号设备
            AllGroup:'',
            groupid:sessionStorage.getItem('groupid'),
            //小绿叶蝉的开关1控制数据
            sw:{"attrs":{
                "onoff1":1
                }
            },
            //小绿叶蝉的开关2控制数据
            sw_L_2:{
                "attrs":{
                "onoff2":1
                }
            },
            //小绿叶蝉的开关3控制数据
            sw_L_3:{
                "attrs":{
                "onoff3":1
                }
            },
            //小绿叶蝉的开关4控制数据
            sw_L_4:{
                "attrs":{
                "onoff4":1
                }
            },
            //一号设备开关1的控制数据
            sw_1:{
                "attrs":{
                    "onoff1":0
                }
            },
            //一号设备开关2的控制数据
            sw_1_2:{
                "attrs":{
                    "onoff2":0
                }
            },
            //一号设备开关3的控制数据
            sw_1_3:{
                "attrs":{
                    "onoff3":0
                }
            },
            //一号设备开关4的控制数据
            sw_1_4:{
                "attrs":{
                    "onoff4":0
                }
            },
            //二号设备开关1的控制数据
            sw_2:{
                "attrs":{
                    "onoff1":1
                }
            },
            //二号设备开关2的控制数据
            sw_2_2:{
                "attrs":{
                    "onoff2":1
                }
            },
            //二号设备开关3的控制数据
            sw_2_3:{
                "attrs":{
                    "onoff3":1
                }
            },
            //二号设备开关4的控制数据
            sw_2_4:{
                "attrs":{
                    "onoff4":1
                }
            },
            //三号设备开关1的控制数据
            sw_3:{
                "attrs":{
                    "onoff1":1
                }
            },
            //三号设备开关2的控制数据
            sw_3_2:{
                "attrs":{
                    "onoff2":1
                }
            },
            //三号设备开关3的控制数据
            sw_3_3:{
                "attrs":{
                    "onoff3":1
                }
            },
            //三号设备开关4的控制数据
            sw_3_4:{
                "attrs":{
                    "onoff4":1
                }
            },
            //四号设备开关1的控制数据
            sw_4:{
                "attrs":{
                    "onoff1":1
                }
            },
            //四号设备开关2的控制数据
            sw_4_2:{
                "attrs":{
                    "onoff2":1
                }
            },
            //四号设备开关3的控制数据
            sw_4_3:{
                "attrs":{
                    "onoff3":1
                }
            },
            //四号设备开关4的控制数据
            sw_4_4:{
                "attrs":{
                    "onoff4":1
                }
            },
            //五号设备开关1的控制数据
            sw_5:{
                "attrs":{
                    "onoff1":1
                }
            },
            //五号设备开关2的控制数据
            sw_5_2:{
                "attrs":{
                    "onoff2":1
                }
            },
            //五号设备开关3的控制数据
            sw_5_3:{
                "attrs":{
                    "onoff3":1
                }
            },
            //五号设备开关4的控制数据
            sw_5_4:{
                "attrs":{
                    "onoff4":1
                }
            },
            //六号设备开关1的控制数据
            sw_6:{
                "attrs":{
                    "onoff1":1
                }
            },
            //六号设备开关2的控制数据
            sw_6_2:{
                "attrs":{
                    "onoff2":1
                }
            },
            //六号设备开关3的控制数据
            sw_6_3:{
                "attrs":{
                    "onoff3":1
                }
            },
            //六号设备开关4的控制数据
            sw_6_4:{
                "attrs":{
                    "onoff4":1
                }
            },
        }
    },
    created(){
        this.getData();
        this.getDevices();
        //绿叶蝉开关
        this.getStatus()
        this.getStatus_1()//开关1的状态
        this.getStatus_2()//开关2的状态
        this.getStatus_3()
        this.getStatus_4()
        this.getStatus_5()
        this.getStatus_6()
        this.test()
    },
    methods: {
        test(){
          let did='j8vjXFsuPx1vygLsRgtRHG'
          this.$http.get(`/app/control/${did}`).then(res=>{
              console.log("我是",res);
          })
        },
        //获取小绿叶蝉的设备最新状态
        getStatus(){
            let did = 'PdSZlnJ1HbdhH1AKiTX87u'
            this.$http.get(`/app/devices/${did}`).then(result => {
                // console.log("状态："+JSON.stringify(result))
                // console.log("状态",result.data.is_online)
                console.log("result",result);
                this.LV_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                console.log("我是res",res);
                //更新一号开关状态
                if(res.data.attr.onoff1 == 1){
                    this.KG = true
                    this.sw.attrs.onoff1 = 0
                }else{
                    this.KG = false
                    this.sw.attrs.onoff1 = 1
                }
                //更新2号开关状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_L_2 = true
                    this.sw_L_2.attrs.onoff2 = 0
                }else{
                    this.KG_L_2 = false
                    this.sw_L_2.attrs.onoff2 = 1
                }
                //更新3号开关状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_L_3 = true
                    this.sw_L_3.attrs.onoff3 = 0
                }else{
                    this.KG_L_3 = false
                    this.sw_L_3.attrs.onoff3 = 1
                }
                //更新4号开关状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_L_4 = true
                    this.sw_L_4.attrs.onoff4 = 0
                }else{
                    this.KG_L_4 = false
                    this.sw_L_4.attrs.onoff4 = 1
                }
            })
        },
        //一号设备的最新状态
        getStatus_1(){
            let did = 'gHgRZBHzk6bDUuS9iubrUL'
            this.$http.get(`/app/devices/${did}`).then(result => {
                //console.log("状态："+JSON.stringify(result))
                //console.log(result.data.is_online)
                this.DEVICE_1_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                //开关1的最新状态
                if(res.data.attr.onoff1 == 1){
                    this.KG_1 = true
                    this.sw_1.attrs.onoff1 = 0
                }else{
                    this.KG_1 = false
                    this.sw_1.attrs.onoff1 = 1
                }
                //开关2的最新状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_1_2 = true
                    this.sw_1_2.attrs.onoff2 = 0
                }else{
                    this.KG_1_2 = false
                    this.sw_1_2.attrs.onoff2 = 1
                }
                //开关3的最新状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_1_3 = true
                    this.sw_1_3.attrs.onoff3 = 0
                }else{
                    this.KG_1_3 = false
                    this.sw_1_3.attrs.onoff3 = 1
                }
                //开关4的最新状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_1_4 = true
                    this.sw_1_4.attrs.onoff4 = 0
                }else{
                    this.KG_1_4 = false
                    this.sw_1_4.attrs.onoff4 = 1
                }
            })
        },
        //二号设备的最新状态
        getStatus_2(){
            let did = 'cpBh3cv3kRUjyANAmJDHFW'
            this.$http.get(`/app/devices/${did}`).then(result => {
                //console.log("状态："+JSON.stringify(result))
                //console.log(result.data.is_online)
                this.DEVICE_2_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                //更新1号开关的最新状态
                if(res.data.attr.onoff1 == 1){
                    this.KG_2 = true
                    this.sw_2.attrs.onoff1 = 0
                }else{
                    this.KG_2 = false
                    this.sw_2.attrs.onoff1 = 1
                }
                //更新2号开关的最新状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_2_2 = true
                    this.sw_2_2.attrs.onoff2 = 0
                }else{
                    this.KG_2_2 = false
                    this.sw_2_2.attrs.onoff2 = 1
                }
                //更新3号开关的最新状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_2_3 = true
                    this.sw_2_3.attrs.onoff3 = 0
                }else{
                    this.KG_2_3 = false
                    this.sw_2_3.attrs.onoff3 = 1
                }
                //更新4号开关的最新状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_2_4 = true
                    this.sw_2_4.attrs.onoff4 = 0
                }else{
                    this.KG_2_4 = false
                    this.sw_2_4.attrs.onoff4 = 1
                }
            })
        },
        //三号设备的最新状态
        getStatus_3(){
            let did = '4TiPEfbkEgPBT8Pd59gLHH'
            this.$http.get(`/app/devices/${did}`).then(result => {
                //console.log("状态："+JSON.stringify(result))
                //console.log(result.data.is_online)
                this.DEVICE_3_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                //更新1号开关的最新状态
                if(res.data.attr.onoff1 == 1){
                    this.KG_3 = true
                    this.sw_3.attrs.onoff1 = 0
                }else{
                    this.KG_3 = false
                    this.sw_3.attrs.onoff1 = 1
                }
                //更新2号开关的最新状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_3_2 = true
                    this.sw_3_2.attrs.onoff2 = 0
                }else{
                    this.KG_3_2 = false
                    this.sw_3_2.attrs.onoff2 = 1
                }
                //更新3号开关的最新状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_3_3 = true
                    this.sw_3_3.attrs.onoff3 = 0
                }else{
                    this.KG_3_3 = false
                    this.sw_3_3.attrs.onoff3 = 1
                }
                //更新4号开关的最新状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_3_4 = true
                    this.sw_3_4.attrs.onoff4 = 0
                }else{
                    this.KG_3_4 = false
                    this.sw_3_4.attrs.onoff4 = 1
                }
            })
        },
        //四号设备的最新状态
        getStatus_4(){
            let did = 'byeg9jMmiX6ZTbD7mi2f6R'
            this.$http.get(`/app/devices/${did}`).then(result => {
                //console.log("状态："+JSON.stringify(result))
                //console.log(result.data.is_online)
                this.DEVICE_4_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                //更新1号开关的最新状态
                if(res.data.attr.onoff1 == 1){
                    this.KG_4 = true
                    this.sw_4.attrs.onoff1 = 0
                }else{
                    this.KG_4 = false
                    this.sw_4.attrs.onoff1 = 1
                }
                //更新2号开关的最新状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_4_2 = true
                    this.sw_4_2.attrs.onoff2 = 0
                }else{
                    this.KG_4_2 = false
                    this.sw_4_2.attrs.onoff2 = 1
                }
                //更新3号开关的最新状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_4_3 = true
                    this.sw_4_3.attrs.onoff3 = 0
                }else{
                    this.KG_4_3 = false
                    this.sw_4_3.attrs.onoff3 = 1
                }
                //更新4号开关的最新状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_4_4 = true
                    this.sw_4_4.attrs.onoff4 = 0
                }else{
                    this.KG_4_4 = false
                    this.sw_4_4.attrs.onoff4 = 1
                }
            })
        },
        //五号设备的最新状态
        getStatus_5(){
            let did = 'SUipng4QSfMUKKtbYebgYi'
            this.$http.get(`/app/devices/${did}`).then(result => {
                //console.log("状态："+JSON.stringify(result))
                //console.log(result.data.is_online)
                this.DEVICE_5_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                //更新1号开关的最新状态
                if(res.data.attr.onoff1 == 1){
                    this.KG_5 = true
                    this.sw_5.attrs.onoff1 = 0
                }else{
                    this.KG_5 = false
                    this.sw_5.attrs.onoff1 = 1
                }
                //更新2号开关的最新状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_5_2 = true
                    this.sw_5_2.attrs.onoff2 = 0
                }else{
                    this.KG_5_2 = false
                    this.sw_5_2.attrs.onoff2 = 1
                }
                //更新3号开关的最新状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_5_3 = true
                    this.sw_5_3.attrs.onoff3 = 0
                }else{
                    this.KG_5_3 = false
                    this.sw_5_3.attrs.onoff3 = 1
                }
                //更新4号开关的最新状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_5_4 = true
                    this.sw_5_4.attrs.onoff4 = 0
                }else{
                    this.KG_5_4 = false
                    this.sw_5_4.attrs.onoff4 = 1
                }
            })
        },
        //六号设备的最新状态
        getStatus_6(){
            let did = 'TwDNj9mEU5QUwvT6tFCPVL'
            this.$http.get(`/app/devices/${did}`).then(result => {
                //console.log("状态："+JSON.stringify(result))
                //console.log(result.data.is_online)
                this.DEVICE_6_isOnline = result.data.is_online
            })
            this.$http.get(`/app/devdata/${did}/latest`).then(res=>{
                //console.log(res.data.attr.onoff1)
                //更新1号开关的最新状态
                if(res.data.attr.onoff1 == 1){
                    this.KG_6 = true
                    this.sw_6.attrs.onoff1 = 0
                }else{
                    this.KG_6 = false
                    this.sw_6.attrs.onoff1 = 1
                }
                //更新2号开关的最新状态
                if(res.data.attr.onoff2 == 1){
                    this.KG_6_2 = true
                    this.sw_6_2.attrs.onoff2 = 0
                }else{
                    this.KG_6_2 = false
                    this.sw_6_2.attrs.onoff2 = 1
                }
                //更新3号开关的最新状态
                if(res.data.attr.onoff3 == 1){
                    this.KG_6_3 = true
                    this.sw_6_3.attrs.onoff3 = 0
                }else{
                    this.KG_6_3 = false
                    this.sw_6_3.attrs.onoff3 = 1
                }
                //更新4号开关的最新状态
                if(res.data.attr.onoff4 == 1){
                    this.KG_6_4 = true
                    this.sw_6_4.attrs.onoff4 = 0
                }else{
                    this.KG_6_4 = false
                    this.sw_6_4.attrs.onoff4 = 1
                }
            })
        },
        //获取当前用户下的设备全部分组
        getData(){
            this.$http.get('/app/group').then(res=>{
                this.AllGroup = res.data
                sessionStorage.setItem('groupid',this.AllGroup[3].id)
                //console.log(this.groupid)
            })
        },
         //获取该分组下的全部设备
        getDevices(){          
            let id = this.groupid//该id为分组的id
            this.$http.get(`/app/group/${id}/devices`).then(res=>{
                sessionStorage.setItem('did',res.data)
                //console.log(res.data)
            })
        },
        //小绿叶蝉1号开关控制
        Onoff(){
            
            let did = 'PdSZlnJ1HbdhH1AKiTX87u'//小绿叶蝉
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw)).then(res=>{
                //this.getStatus()
                console.log('绿叶1')
            })
            setTimeout(()=>{
                this.getStatus()
                if(this.sw.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
            //console.log(this.value)
        },
        //小绿叶蝉2号开关控制
        Onoff_L_2(){
            let did = 'PdSZlnJ1HbdhH1AKiTX87u'//小绿叶蝉
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_L_2)).then(res=>{
                //this.getStatus()
                console.log('绿叶2')
            })
            setTimeout(()=>{
                this.getStatus()
                if(this.sw_L_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //小绿叶蝉3号开关控制
        Onoff_L_3(){
            let did = 'PdSZlnJ1HbdhH1AKiTX87u'//小绿叶蝉
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_L_3)).then(res=>{
                //this.getStatus()
                console.log('绿叶3')
            })
            setTimeout(()=>{
                this.getStatus()
                if(this.sw_L_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //小绿叶蝉4号开关控制
        Onoff_L_4(){
            let did = 'PdSZlnJ1HbdhH1AKiTX87u'//小绿叶蝉
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_L_4)).then(res=>{
                //this.getStatus()
                console.log('绿叶4')
            })
            setTimeout(()=>{
                this.getStatus()
                if(this.sw_L_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //一号设备开关1的控制
        Onoff_1(){
            let did = 'gHgRZBHzk6bDUuS9iubrUL'//一号设备
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_1)).then(res=>{
                //this.getStatus_1()
                console.log('设备1开关1')
            })
            setTimeout(()=>{
                this.getStatus_1()
                if(this.sw_1.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //一号设备开关2的控制
        Onoff_1_2(){
            let did = 'gHgRZBHzk6bDUuS9iubrUL'//一号设备
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_1_2)).then(res=>{
                //this.getStatus_1()
                console.log('设备1开关2')
            })
            setTimeout(()=>{
                this.getStatus_1()
                if(this.sw_1_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //一号设备开关3的控制
        Onoff_1_3(){
            let did = 'gHgRZBHzk6bDUuS9iubrUL'//一号设备
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_1_3)).then(res=>{
                //this.getStatus_1()
                console.log('222')
            })
            setTimeout(()=>{
                this.getStatus_1()
                if(this.sw_1_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //一号设备开关4的控制
        Onoff_1_4(){
            let did = 'gHgRZBHzk6bDUuS9iubrUL'//一号设备
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_1_4)).then(res=>{
                //this.getStatus_1()
                console.log('222')
            })
            setTimeout(()=>{
                this.getStatus_1()
                if(this.sw_1_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //二号设备开关1的控制
        Onoff_2(){
            let did = 'cpBh3cv3kRUjyANAmJDHFW'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_2)).then(res=>{
                //this.getStatus_2()
                console.log('333')
            })
            setTimeout(()=>{
                this.getStatus_2()
                if(this.sw_2.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //二号设备开关2的控制
        Onoff_2_2(){
            let did = 'cpBh3cv3kRUjyANAmJDHFW'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_2_2)).then(res=>{
                //this.getStatus_2()
                console.log('333')
            })
            setTimeout(()=>{
                this.getStatus_2()
                if(this.sw_2_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //二号设备开关3的控制
        Onoff_2_3(){
            let did = 'cpBh3cv3kRUjyANAmJDHFW'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_2_3)).then(res=>{
                //this.getStatus_2()
                console.log('333')
            })
            setTimeout(()=>{
                this.getStatus_2()
                if(this.sw_2_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //二号设备开关4的控制
        Onoff_2_4(){
            let did = 'cpBh3cv3kRUjyANAmJDHFW'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_2_4)).then(res=>{
                //this.getStatus_2()
                console.log('333')
            })
            setTimeout(()=>{
                this.getStatus_2()
                if(this.sw_2_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //三号设备开关1的控制
        Onoff_3(){
            let did = '4TiPEfbkEgPBT8Pd59gLHH'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_3)).then(res=>{
                //this.getStatus_3()
                console.log('444')
            })
            setTimeout(()=>{
                this.getStatus_3()
                if(this.sw_3.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //三号设备开关2的控制
        Onoff_3_2(){
            let did = '4TiPEfbkEgPBT8Pd59gLHH'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_3_2)).then(res=>{
                //this.getStatus_3()
                console.log('444')
            })
            setTimeout(()=>{
                this.getStatus_3()
                if(this.sw_3_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //三号设备开关3的控制
        Onoff_3_3(){
            let did = '4TiPEfbkEgPBT8Pd59gLHH'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_3_3)).then(res=>{
                //this.getStatus_3()
                console.log('444')
            })
            setTimeout(()=>{
                this.getStatus_3()
                if(this.sw_3_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //三号设备开关4的控制
        Onoff_3_4(){
            let did = '4TiPEfbkEgPBT8Pd59gLHH'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_3_4)).then(res=>{
                //this.getStatus_3()
                console.log('444')
            })
            setTimeout(()=>{
                this.getStatus_3()
                if(this.sw_3_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //四号设备开关1的控制
        Onoff_4(){
            let did = 'byeg9jMmiX6ZTbD7mi2f6R'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_4)).then(res=>{
                //this.getStatus_4()
                console.log('555')
            })
            setTimeout(()=>{
                this.getStatus_4()
                if(this.sw_4.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //四号设备开关2的控制
        Onoff_4_2(){
            let did = 'byeg9jMmiX6ZTbD7mi2f6R'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_4_2)).then(res=>{
                //this.getStatus_4()
                console.log('555')
            })
            setTimeout(()=>{
                this.getStatus_4()
                if(this.sw_4_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //四号设备开关3的控制
        Onoff_4_3(){
            let did = 'byeg9jMmiX6ZTbD7mi2f6R'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_4_3)).then(res=>{
                //this.getStatus_4()
                console.log('555')
            })
            setTimeout(()=>{
                this.getStatus_4()
                if(this.sw_4_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //四号设备开关4的控制
        Onoff_4_4(){
            let did = 'byeg9jMmiX6ZTbD7mi2f6R'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_4_4)).then(res=>{
                //this.getStatus_4()
                console.log('555')
            })
            setTimeout(()=>{
                this.getStatus_4()
                if(this.sw_4_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //五号设备开关1的控制
        Onoff_5(){
            let did = 'SUipng4QSfMUKKtbYebgYi'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_5)).then(res=>{
                this.getStatus_5()
                console.log('666')
            })
            setTimeout(()=>{
                this.getStatus_5()
                if(this.sw_5.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //五号设备开关2的控制
        Onoff_5_2(){
            let did = 'SUipng4QSfMUKKtbYebgYi'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_5_2)).then(res=>{
                //this.getStatus_5()
                console.log('666')
            })
            setTimeout(()=>{
                this.getStatus_5()
                if(this.sw_5_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //五号设备开关3的控制
        Onoff_5_3(){
            let did = 'SUipng4QSfMUKKtbYebgYi'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_5_3)).then(res=>{
                //this.getStatus_5()
                console.log('666')
            })
            setTimeout(()=>{
                this.getStatus_5()
                if(this.sw_5_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //五号设备开关4的控制
        Onoff_5_4(){
            let did = 'SUipng4QSfMUKKtbYebgYi'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_5_4)).then(res=>{
                //this.getStatus_5()
                console.log('666')
            })
            setTimeout(()=>{
                this.getStatus_5()
                if(this.sw_5_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //六号设备开关1的控制
        Onoff_6(){
            let did = 'TwDNj9mEU5QUwvT6tFCPVL'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_6)).then(res=>{
                //this.getStatus_6()
                console.log('777')
            })
            setTimeout(()=>{
                this.getStatus_6()
                if(this.sw_6.attrs.onoff1 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //六号设备开关2的控制
        Onoff_6_2(){
            let did = 'TwDNj9mEU5QUwvT6tFCPVL'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_6_2)).then(res=>{
                //this.getStatus_6()
                console.log('777')
            })
            setTimeout(()=>{
                this.getStatus_6()
                if(this.sw_6_2.attrs.onoff2 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //六号设备开关3的控制
        Onoff_6_3(){
            let did = 'TwDNj9mEU5QUwvT6tFCPVL'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_6_3)).then(res=>{
                //this.getStatus_6()
                console.log('777')
            })
            setTimeout(()=>{
                this.getStatus_6()
                if(this.sw_6_3.attrs.onoff3 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
        //六号设备开关4的控制
        Onoff_6_4(){
            let did = 'TwDNj9mEU5QUwvT6tFCPVL'
            this.$http.post(`/app/control/${did}`,JSON.stringify(this.sw_6_4)).then(res=>{
                //this.getStatus_6()
                console.log('777')
            })
            setTimeout(()=>{
                this.getStatus_6()
                if(this.sw_6_4.attrs.onoff4 == 0){
                    this.$message({
                        message: '关闭成功',
                        type: 'warning'
                    });
                }else{
                    this.$message({
                        message: '开启成功',
                        type: 'success'
                    });
                }
            }, 5000);
        },
    },
    // watch:{
    //     sw(newVal,oldVal){
    //         this.KG = !this.KG
    //     }
    // }
})
</script>

<style scoped>
@media screen and (max-width: 767px){
    html,body{
        margin: 0;
        padding: 0;
    }
    .BT{
        margin: auto 0;
        width: 100%;
        height: 22px;
        text-align: center;
    }
    .cebao{
        width: 300px;
        height: 250px;
        margin: 0 auto;
        margin-top: 20px;
        
    }
    .cbdata{
        width: 230px;
        height: 230px;
        margin-top: 20px;
        margin: 0 auto;
        margin-left: 110px;
        
    }
    .moniter{
        color: #ff0000;
        font-weight: bold;
    }
    .beian {
            position: fixed;
            width: 100%;
            height: 10px;
            bottom: 40px;
            margin: 0 auto;
            right: 0;
            text-align: center;
	    color:rgb(0, 0, 0);
        }
      .container{
        width:100%;
        margin: 0 auto;
        
        padding: 0;
        height: 180%;
        background-image: url("../assets/mo_1.jpg");     
        background-repeat: no-repeat;  
        background-size: 100% 100%;
      }
      .container_switch{
        width: 300px;
        margin: 0 auto;
        
        
      }
      .LV_title{
        float:left;
      }
      .LV_1{
        float:left;
        margin-left: 5px;
      }
      .LV_2,.LV_4{
        
        left: px;
      }
      .LV_3{
      margin-left: 25%;
      float: left;
      }
      
      .Dev_1_title{
        display: inline-block;
      }
      .Dev_1_1{
          margin-left: 2px;
          display: inline-block;
         
      }
      .Dev_1_2{
          display: inline-block;
         
      }
      .JK_1{
          float: left;
      }
      .Dev_1_3{
      float: left;
      margin-left: 9px;
      }
      
      
    


      .Dev_2_title,.Dev_2_1{
      float: left;
      }
      .Dev_2_1{
          margin-left: 5px; 
      }
      .Dev_2_3{
      margin-left: 25%;
      float: left;
      }

    
      .Dev_3_title{
      display: inline-block;
      }
    .Dev_3_1{
        margin-left: 2px; 
        display: inline-block;
    }
      .Dev_3_2{
      display: inline-block;
      }
    .JK_3{
        float: left;
    }
    .Dev_3_3{
        float: left;
        margin-left: 9px ;
    }


      .Dev_4_title,.Dev_4_1{
      float: left;
      }
      .Dev_4_1{
         margin-left: 5px; 
      }
      .Dev_4_3{
      margin-left: 25%;
      float: left;
      }

      .Dev_5_title{
      display: inline-block;
      }
      .Dev_5_1{
           margin-left: 2px; 
           display: inline-block;
      }
      .Dev_5_2{
      display: inline-block;
      }
    .JK_5{
        float: left;
    }
    .Dev_5_3{
        float: left;
        margin-left: 9px;
    }
      .Dev_6_title{
      float: left;
      }
      .Dev_6_1{
      float: left;
      margin-left: 5px;
      }
      .Dev_6_2,.Dev_6_4{
      
      left: px;
      }
      .Dev_6_3{
      margin-left: 25%;
      float: left;
      }

      .DEVICE_1 , .DEVICE_2 , .DEVICE_3 , .DEVICE_4 , .DEVICE_5 , .DEVICE_6{
      margin-top: 10px;
      }
}

@media screen and (min-width:992px){
    .moniter{
        color: #00FFFF;
        font-weight: bold;
    }
    .beian {
            position: fixed;
            width: 100%;
            height: 10px;
            bottom: 80px;
            margin: 0 auto;
            right: 0;
            text-align: center;
	    color:rgb(0, 0, 0);
        }
        .BT{
        margin: auto 0;
        width: 100%;
        height: 22px;
        text-align: center;
    }
    .container{
    width: 970px;
    margin: 0 auto;
    }
    .MU{
        display: flex;
        margin: 5px;
    }
    .cebao{
        height: 280px;
        width: 300px;
        margin-left: 200px;
    }
    .cbdata{
        margin-top: 10px;
        width: 250px;
        margin-left: px;
    }
    
    .container_switch{
        width:600px;
        margin: 0 auto;
    }
    .LV_title , .LV_1 , .LV_2 , .LV_3 , .LV_4{
    display: inline-block;
    }
    .Dev_1_title , .Dev_1_1 , .Dev_1_2 , .Dev_1_3 , .Dev_1_4,.JK_1{
    display: inline-block;
    }
    .JK_1{
        float: right;
    }
    .Dev_2_title , .Dev_2_1 , .Dev_2_2 , .Dev_2_3 , .Dev_2_4{
    display: inline-block;
    }
    .Dev_3_title , .Dev_3_1 , .Dev_3_2 , .Dev_3_3 , .Dev_3_4,.JK_3{
    display: inline-block;
    }
    .JK_3{
        float: right;
    }
    .Dev_4_title , .Dev_4_1 , .Dev_4_2 , .Dev_4_3 , .Dev_4_4{
    display: inline-block;
    }
    .Dev_5_title , .Dev_5_1 , .Dev_5_2 , .Dev_5_3 , .Dev_5_4,.JK_5{
    display: inline-block;
    }
    .JK_5{
        float: right;
    }
    .Dev_6_title , .Dev_6_1 , .Dev_6_2 , .Dev_6_3 , .Dev_6_4{
    display: inline-block;
    }
}

</style>
